import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {BaseService} from '@app/core/services/base.service';
import {UserService} from '@app/modules/shared/services/user.service';
import {AuthService} from '@app/core/services/auth.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {Observable} from 'rxjs';
import {ISickDay} from '@app/core/interfaces/sick-days.interface';
import {map} from 'rxjs/operators';
import {ShiftService} from '@app/modules/shared/services/shift.service';
import {PaginationHolder} from '@app/core/models/pagination.model';
import {ISickDayAnswer} from '@app/core/interfaces/sick-day-answer';
import {ISickDayResponse} from '@app/core/interfaces/i-sick-day-response';

@Injectable({
	providedIn: 'root',
})
export class SickDaysService extends BaseService {

	constructor(
		public httpService: HttpService,
		public userService: UserService,
		public authService: AuthService,
		public interService: InternationalizationService,
		private shiftService: ShiftService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public getSickDays(): Observable<PaginationHolder<ISickDay>> {
		const filter = {
			page_size: 300,
		};
		if (this.authService.currentUser.permission_level === 1) {
			filter['filter[doesnt_have_auth_user_response]'] = 1;
		}

		return this.httpService.getJson<ISickDay[]>('absentDays/sickMessages', filter).pipe(map((res: PaginationHolder<ISickDay>) => {
			res.data.map(sd => sd.shift = this.shiftService.fresh(sd.shift));

			return res;
		}));
	}

	public postSickDay(payload: { shift_id: number, message: string }): Observable<ISickDay> {
		return this.httpService.postJson<ISickDay>('absentDays/sickMessages', payload).pipe(map((res: any) => {
			res.shift = this.shiftService.fresh(res.shift);

			return res;
		}));
	}

	public deleteSickDay(sickDay: ISickDay): Observable<ISickDay> {
		return this.httpService.deleteJson<ISickDay>('absentDays/sickMessages/' + sickDay.id, {}).pipe(map((res: any) => {
			res.shift = this.shiftService.fresh(res.shift);

			return res;
		}));
	}

	public approveSickDay(sickDay: ISickDay, userId: number): Observable<ISickDay> {
		return this.httpService.patchJson<ISickDay>('absentDays/sickMessages/' + sickDay.id + '/approve', {user_id: userId}).pipe(map((res: ISickDay) => {
			res.shift = this.shiftService.fresh(res.shift);

			return res;
		}));
	}

	public respondSickDay(sickDay: ISickDay, response: boolean): Observable<ISickDayResponse> {
		return this.httpService.postJson<ISickDayResponse>('absentDays/sickMessages/' + sickDay.id + '/responses', {response});
	}

	public getSickDayAnswers(sickDay: ISickDay): Observable<ISickDayAnswer[]> {
		return this.httpService.getJson<ISickDayAnswer[]>('absentDays/sickMessages/' + sickDay.id + '/responses', {page_size: 500}).pipe(map((res: PaginationHolder<ISickDayAnswer>) => {
			res.data.map(d => d.user = this.userService.fresh(d.user));

			return res.data;
		}));
	}

}
